// extracted by mini-css-extract-plugin
export default {"group":"Radio_group__uZNqU","option":"Radio_option__hsIv7","input":"Radio_input__si-LO","label":"Radio_label__lXwTJ","disabled":"Radio_disabled__R4SnD"};